import { createBrowserRouter, Navigate } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import Calculator from './pages/Calculator'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/whitepaper',
    element: <Navigate to="/evida_whitepaper.pdf" replace />,
  },
  {
    path: '/calculator',
    element: <Calculator />,
  },
]) 